import React from 'react'
import MulticuisineRestaurants from "../images/Multicuisine Restaurants.jpg";
import cafe from "../images/vintage_cafe.jpg";

function Restaurant() {
  return (
    <div>
           <div className='album py-0'>
        <div className='container'>
          <div className="row">
        
            <div className="col-md-12 mt-2">
            <div className="card-group">
  <div className="card">
    <img src={MulticuisineRestaurants} className="card-img-top" alt="MulticuisineRestaurants"/>
    <div className="card-body">
    <a href="multicuisine-menu">
                                <button className="resortbookberhampore" type="submit">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>
                            </a>
      
    </div>
    <div className="card-footer">
      <small className="text-muted"><b style={{color:"maroon"}}>MULTICUISINE RESTAURANT</b></small>
    </div>
  </div>
 
  <div className="card">
    <img src={cafe} className="card-img-top" alt="cafe"/>
    <div className="card-body">
    <a href="Vintagecafe">
                                <button className="resortbookberhampore" type="submit">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>
                            </a>
    </div>
    <div className="card-footer">
      <small className="text-muted"><b style={{color:"maroon"}}>VINTAGE CAFE</b></small>
    </div>
  </div>
</div>
               </div>
                </div>
                </div>
            </div>




    </div>
  )
}

export default Restaurant